import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Loader, Tabs } from 'redpoints-front-components/index';

import {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchContentLinkData,
  incidentDetailsFetchContentLinkEvidences,
  incidentDetailsFetchContentLinkMetaData,
  incidentDetailsFetchContentLinkRelatedAds,
  incidentDetailsFetchDestinationLinks,
  incidentDetailsFetchDetectionLinkData,
  incidentDetailsFetchDetectionLinkEvidences,
  incidentDetailsFetchDetectionLinkMetaData,
  incidentDetailsFetchDetectionLinkRelatedAds,
  incidentDetailsFetchLinkMonitorData,
} from '../../../actions/incidentDetailsActions';
import {
  getIncidentDetailsContentLinkDataIsLoading,
  getIncidentDetailsDetectionLinkDataIsLoading,
  getIncidentDetailsIncidentData,
  getIncidentDetailsIsAdDetectionLink,
} from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsContentLinkContent from './IncidentDetailsContentLinkContent';
import IncidentDetailsDetectionLinkContent from './IncidentDetailsDetectionLinkContent';
import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkData = ({
  incidentData,
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchContentLinkData,
  incidentDetailsFetchContentLinkEvidences,
  incidentDetailsFetchContentLinkMetaData,
  incidentDetailsFetchContentLinkRelatedAds,
  incidentDetailsFetchDestinationLinks,
  incidentDetailsFetchDetectionLinkData,
  incidentDetailsFetchDetectionLinkEvidences,
  incidentDetailsFetchDetectionLinkMetaData,
  incidentDetailsFetchDetectionLinkRelatedAds,
  incidentDetailsFetchLinkMonitorData,
  isAdDetectionLink,
  isContentLinkLoading,
  isDetectionLinkLoading,
}) => {
  const assetId = incidentData?.asset?.assetId;
  const contentLinkId = incidentData?.contentLink?.contentLinkId;
  const contentLinkChannelId =
    incidentData?.contentLink?.domain?.effectiveConfiguration?.channel
      ?.channelId;

  const detectionLinkId = incidentData?.detectionLink?.detectionLinkId;
  const detectionLinkChannelId =
    incidentData?.detectionLink?.domain?.effectiveConfiguration?.channel
      ?.channelId;

  useEffect(() => {
    if (contentLinkId != null) {
      incidentDetailsFetchContentLinkData({ contentLinkId });
      incidentDetailsFetchContentLinkMetaData({
        channelId: contentLinkChannelId,
      });
      incidentDetailsFetchContentLinkEvidences({ contentLinkId });
      incidentDetailsFetchChannelEvidencesTypes({
        channelId: contentLinkChannelId,
      });
      incidentDetailsFetchLinkMonitorData({
        assetId,
        linkId: contentLinkId,
        isContentLink: true,
      });

      incidentDetailsFetchContentLinkRelatedAds({ contentLinkId, assetId });
    }

    if (detectionLinkId != null) {
      incidentDetailsFetchDetectionLinkData({ detectionLinkId });
      incidentDetailsFetchDetectionLinkMetaData({
        channelId: detectionLinkChannelId,
      });
      incidentDetailsFetchDetectionLinkEvidences({ detectionLinkId });
      incidentDetailsFetchChannelEvidencesTypes({
        channelId: detectionLinkChannelId,
      });
      incidentDetailsFetchLinkMonitorData({
        assetId,
        linkId: detectionLinkId,
        isContentLink: false,
      });
      if (isAdDetectionLink) {
        incidentDetailsFetchDestinationLinks({
          adLinkId: detectionLinkId,
          assetId,
        });
      } else {
        incidentDetailsFetchDetectionLinkRelatedAds({
          detectionLinkId,
          assetId,
        });
      }
    }
  }, [
    assetId,
    contentLinkChannelId,
    contentLinkId,
    detectionLinkChannelId,
    detectionLinkId,
    incidentDetailsFetchChannelEvidencesTypes,
    incidentDetailsFetchContentLinkData,
    incidentDetailsFetchContentLinkEvidences,
    incidentDetailsFetchContentLinkMetaData,
    incidentDetailsFetchContentLinkRelatedAds,
    incidentDetailsFetchDestinationLinks,
    incidentDetailsFetchDetectionLinkData,
    incidentDetailsFetchDetectionLinkEvidences,
    incidentDetailsFetchDetectionLinkMetaData,
    incidentDetailsFetchDetectionLinkRelatedAds,
    incidentDetailsFetchLinkMonitorData,
    isAdDetectionLink,
  ]);

  const isLoading = isContentLinkLoading || isDetectionLinkLoading;

  return (
    <Loader isLoading={isLoading}>
      <Tabs defaultActiveKey="detectionLink">
        <Tabs.TabPane
          tab={translate('reporting.incidentDetails.tabs.detectionLink')}
          key="detectionLink"
        >
          <IncidentDetailsDetectionLinkContent />
        </Tabs.TabPane>

        {contentLinkId && (
          <Tabs.TabPane
            tab={translate('reporting.incidentDetails.tabs.contentLink')}
            key="contentLink"
            forceRender
          >
            <IncidentDetailsContentLinkContent />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Loader>
  );
};

const mapStateToProps = state => ({
  incidentData: getIncidentDetailsIncidentData(state),
  isAdDetectionLink: getIncidentDetailsIsAdDetectionLink(state),
  isContentLinkLoading: getIncidentDetailsContentLinkDataIsLoading(state),
  isDetectionLinkLoading: getIncidentDetailsDetectionLinkDataIsLoading(state),
});

export default connect(mapStateToProps, {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchContentLinkData,
  incidentDetailsFetchContentLinkEvidences,
  incidentDetailsFetchContentLinkMetaData,
  incidentDetailsFetchContentLinkRelatedAds,
  incidentDetailsFetchDestinationLinks,
  incidentDetailsFetchDetectionLinkData,
  incidentDetailsFetchDetectionLinkEvidences,
  incidentDetailsFetchDetectionLinkMetaData,
  incidentDetailsFetchDetectionLinkRelatedAds,
  incidentDetailsFetchLinkMonitorData,
})(IncidentDetailsLinkData);
